module.exports = __webpack_public_path__ + "static/media/dg_3.1bdc3831.png";